import { AddressModel } from './address';
import { BaseEntity, MemoizeGetters, Transform, toEntity } from './base';

@MemoizeGetters
export class UserAddressModel extends BaseEntity {
  locationName?: string; // TODO: OPS only, remove when API permits

  @Transform(toEntity(AddressModel))
  address?: AddressModel;
}



// WEBPACK FOOTER //
// ./src/models/user-address.ts